import { useQuery } from "@tanstack/react-query"

import { getEstudio } from "../services/estudio.service";

export const useEstudio = () => {

    const estudioQuery = useQuery({
        queryKey: ['estudio'],
        queryFn: () => getEstudio(),
        staleTime: 1000 * 60 * 5, // 5 minutos
    });

    return {
        estudioQuery,
    }
}